module.exports = __webpack_public_path__ + "static/media/vehicle_changes.03ac6f15.svg";